// eslint-disable-next-line import/prefer-default-export
export const getCourseColor = type => {
  switch (type) {
    case 1:
      return '#00A6B1';
    case 2:
      return '#069EF2';
    case 3:
      return '#0B24D8';
    case 4:
      return '#002454';
    default:
      return '#069EF2';
  }
};

export const getCourseIconPath = type => {
  switch (type) {
    case 1:
      return 'img/courses/csharp.svg';
    case 2:
      return 'img/courses/javascript.svg';
    case 3:
      return 'img/courses/typescript.svg';
    case 4:
      return 'img/courses/nodejs.svg';
    default:
      return '#069EF2';
  }
};

export const getCourseImage = type => {
  switch (type) {
    case 1:
      return 'img/courses/csharp-profile.svg';
    case 2:
      return 'img/courses/javascript-profile.svg';
    case 3:
      return 'img/courses/typescript-profile.svg';
    case 4:
      return 'img/courses/nodejs-profile.svg';
    default:
      return '';
    // TODO default image
  }
};

export const getWhiteCourseIconPath = type => {
  switch (type) {
    case 1:
      return 'img/courses/csharp-white.svg';
    case 2:
      return 'img/courses/javascript-white.svg';
    case 3:
      return 'img/courses/typescript-white.svg';
    case 4:
      return 'img/courses/nodejs-white.svg';
    default:
      return 'Unknown';
  }
};

export const courseTypeToString = type => {
  switch (type) {
    case 1:
      return 'C#';
    case 2:
      return 'Javascript';
    case 3:
      return 'Typescript';
    case 4:
      return 'Nodejs';
    default:
      return 'Unknown';
  }
};

export const courseLevelToString = level => {
  switch (level) {
    case 1:
      return 'BEGINNER';
    case 2:
      return 'INTERMEDIATE';
    case 3:
      return 'ADVANCED';
    default:
      return 'ADVANCED';
  }
};
